import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CreateSkLkrlStoreServiceModule } from '@common/services/my-booking/create-sk-lkrl/create-sk-lkrl.module';
import { AlertAreaModule, ButtonModule, InputModule, RadiobuttonBoxModule, TextTooltipModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { AddLinkedComponent } from './add-linked.component';

@NgModule({
  declarations: [AddLinkedComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    ButtonModule,
    InputModule,
    RadiobuttonBoxModule,
    TextTooltipModule,
    ReactiveFormsModule,
    AlertAreaModule,
    CreateSkLkrlStoreServiceModule,
  ],
  exports: [AddLinkedComponent],
})
export class AddLinkedModule {}
